/**
 * Ergovia sepet yardımcıları: hediye ürünün sepetteki adedini paket kuralına göre ayarlar
 * ve temanın sepet çekmecesini yeniler.
 */

const SOURCE = 'ergo-cart';
const config = JSON.parse(document.getElementById('ergo-cart-config')?.textContent || '{}');
const root = () => window.Shopify?.routes?.root || '/';
const nativeFetch = window.fetch.bind(window);

/** @param {any} cart */
function wantedGiftQuantity(cart) {
  if (!config.giftVariantId || !config.triggerProductId) return null;
  let triggerCount = 0;
  for (const item of cart.items) {
    if (item.product_id === config.triggerProductId) triggerCount += item.quantity;
  }
  if (triggerCount >= 3) return config.giftQty3;
  if (triggerCount >= 2) return config.giftQty2;
  return 0;
}

/**
 * Sepeti okur, hediye adedi kurala uymuyorsa düzeltir.
 * @returns {Promise<{cart: any, changed: boolean}>}
 */
async function syncGifts() {
  let cart = await (await nativeFetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } })).json();
  const wanted = wantedGiftQuantity(cart);
  if (wanted === null) return { cart, changed: false };

  let current = 0;
  for (const item of cart.items) {
    if (item.variant_id === config.giftVariantId) current += item.quantity;
  }
  if (current === wanted) return { cart, changed: false };

  const response = await nativeFetch(`${root()}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates: { [config.giftVariantId]: wanted } }),
  });
  if (response.ok) cart = await response.json();
  return { cart, changed: response.ok };
}

/** @param {any} cart */
function announce(cart) {
  document.dispatchEvent(
    new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: SOURCE, data: { source: SOURCE, itemCount: cart.item_count } },
    })
  );
}

let running = false;

window.ErgoCart = {
  /** Sepete ürün eklendikten sonra çağrılır: hediyeyi ayarlar, çekmeceyi yeniler ve açar. */
  async refresh() {
    running = true;
    try {
      const { cart } = await syncGifts();
      announce(cart);
    } finally {
      running = false;
    }
  },
};

// Sepet içinde adet değişince (ör. çekmecede) hediye adedini yeniden hesapla
document.addEventListener('cart:update', async (event) => {
  const detail = /** @type {CustomEvent} */ (event).detail;
  if (running || detail?.data?.source === SOURCE || detail?.data?.didError) return;
  running = true;
  try {
    const { cart, changed } = await syncGifts();
    if (changed) announce(cart);
  } catch (error) {
    console.error(error);
  } finally {
    running = false;
  }
});

// Sayfa açıldığında sepette kural dışı hediye varsa düzelt
if (config.needsSync) {
  syncGifts()
    .then(({ cart, changed }) => changed && announce(cart))
    .catch(console.error);
}

// Sepetteki ürün önerisi: tek tıkla ekleme
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-ergo-upsell]') : null;
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;
  event.preventDefault();
  button.disabled = true;
  try {
    const response = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.ergoUpsell), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error('add failed');
    await window.ErgoCart.refresh();
  } catch (error) {
    console.error(error);
    button.disabled = false;
  }
});

/**
 * Temanın dışındaki araçlar (ör. kapıda ödeme formu) sepeti doğrudan değiştirdiğinde de hediye kuralı uygulanır.
 * İstek tamamlanınca hediye adedi düzeltilir ve araç güncel sepeti görsün diye yanıt güncel sepetle değiştirilir.
 * Temanın kendi istekleri ("sections" içerenler) zaten cart:update olayıyla ele alındığı için atlanır.
 */
function announceQuietly(/** @type {any} */ cart) {
  // Çekmece açılmadan içerik yenilenir (üstte başka bir form açık olabilir)
  const drawer = document.querySelector('cart-drawer-component');
  const autoOpen = drawer?.hasAttribute('auto-open');
  if (autoOpen) drawer?.removeAttribute('auto-open');
  announce(cart);
  if (autoOpen) drawer?.setAttribute('auto-open', '');
}

window.fetch = async function ergoFetch(input, init) {
  const response = await nativeFetch(input, init);
  try {
    if (!config.giftVariantId || !response.ok) return response;
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input?.url || '';
    const method = String(init?.method || (typeof input === 'object' && 'method' in input ? input.method : 'GET')).toUpperCase();
    const kind = (url.match(/\/cart\/(add|update|change|clear)(?:\.js)?(?:\?|$)/) || [])[1];
    if (method !== 'POST' || !kind) return response;

    const body = init?.body;
    const hasSections =
      url.includes('sections=') ||
      (typeof body === 'string' && body.includes('sections')) ||
      (body instanceof FormData && body.has('sections')) ||
      (body instanceof URLSearchParams && body.has('sections'));
    if (hasSections || running) return response;

    running = true;
    try {
      const { cart, changed } = await syncGifts();
      if (!changed) return response;
      announceQuietly(cart);
      if (kind === 'update' || kind === 'change') {
        return new Response(JSON.stringify(cart), {
          status: 200,
          headers: { 'Content-Type': 'application/json; charset=utf-8' },
        });
      }
    } finally {
      running = false;
    }
  } catch (error) {
    console.error(error);
  }
  return response;
};
